import './MaintenanceView.scss';
import React from 'react';
import { EMAILS, MAINTENANCE_COPY, URLS } from '@sonar-software/sonar-ts-constants';
import { GatewayCard, GatewayContent } from '../general';

export const MaintenanceView: React.FC = () =>
	<GatewayContent>
		<GatewayCard
			className='maintenance-view'
			title={ MAINTENANCE_COPY.PAGE_HEADER }>
			<div className='maintenance-image' />
			<p>
				{ MAINTENANCE_COPY.PAGE_SUBTEXT_PARTIAL_1 }
				<a
					href={ URLS.SUPPORT_EMAIL }
					rel='noopener'
					target='_blank'>
					{ EMAILS.SUPPORT }
				</a>
				{ MAINTENANCE_COPY.PAGE_SUBTEXT_PARTIAL_2 }
			</p>
		</GatewayCard>
	</GatewayContent>;
